import { Grid, useAppDispatch } from '../../base';
import {
    ChangePasswordGrid,
    ChangePasswordWrapper,
} from './ChangePasswordPage.styles';
import { ReactSVG } from 'react-svg';
import { loginActions } from '../../actions';
import ResetPasswordForm from '../../components/ResetPasswordForm/ResetPasswordForm';

const ChangePasswordPage = () => {
    const dispatch = useAppDispatch();

    const onChangePasswordSubmit = (payload: { new_password: string }) => {
        dispatch(loginActions.fetchChangePassword(payload));
    };

    return (
        <ChangePasswordWrapper>
            <ChangePasswordGrid container>
                <Grid
                    item
                    xs={12}
                    display={'flex'}
                    justifyContent={'center'}
                    pb={4}
                >
                    <ResetPasswordForm onSubmit={onChangePasswordSubmit} />
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <ReactSVG src={'/src/assets/logo.svg'} />
                </Grid>
            </ChangePasswordGrid>
        </ChangePasswordWrapper>
    );
};

export default ChangePasswordPage;
